import { Box } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod';

import { Section } from '@/components/modules/DocumentsValidation/components/_shared/Section';
import { useDocumentsValidationContext } from '@/components/modules/DocumentsValidation/contexts/DocumentsValidationContext';
import { ValidationDeclaredDataMap } from '@/components/modules/DocumentsValidation/maps/validationDeclaredData.map';
import { FormWrapper } from '@/components/shared/components/FormWrapper';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { GetTextIdTranslationType, useTranslation } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

interface DocumentNumberValidationProps {
  onNext: () => void;
}

const DocumentNumberValidationSchema = (t: GetTextIdTranslationType) =>
  z.object({
    documentNumber: requiredString(t),
  });

export const DocumentNumberValidation = (props: DocumentNumberValidationProps) => {
  return (
    <FormWrapper formSchema={DocumentNumberValidationSchema} defaultValues={{ documentNumber: '' }}>
      <DocumentNumberForm {...props} />
    </FormWrapper>
  );
};

const DocumentNumberForm = ({ onNext }: DocumentNumberValidationProps) => {
  const { borrowerOnboardingDetails } = useDocumentsValidationContext();

  const { getValues, setError, handleSubmit } = useFormContext();
  const { getTextIdTranslation } = useTranslation();

  const { documentNumber } = ValidationDeclaredDataMap.toDocumentIdData(borrowerOnboardingDetails);

  if (!documentNumber) {
    throw new Error('Not able to find documentNumber ');
  }

  const onSubmit = () => {
    if (documentNumber.toLowerCase() !== getValues('documentNumber').trim().toLowerCase()) {
      setError('documentNumber', {
        message: getTextIdTranslation('CLIENT_DOCUMENT_ID_MISMATCH'),
      });
      return;
    }

    onNext();
  };

  return (
    <Section.Content>
      <Section.Header title={'ENTER_CLIENT_DATA'} />
      <Box maxWidth={'300px'}>
        <TextFormField name={'documentNumber'} label={'CLIENT_DOCUMENT_ID'} fieldVariant={FieldVariant.form} />
      </Box>
      <Section.Footer>
        <StandardButton main onClick={handleSubmit(onSubmit)}>
          <Text tId={'CONTINUE'} />
        </StandardButton>
      </Section.Footer>
    </Section.Content>
  );
};
